import { NotificationType } from './model/notification-type';

export const DEFAULT_NOTIFICATION_PRIORIZATION_LEVELS: Record<NotificationType, number> = {
  info: 0,
  refresh: 100000,
  success: 200000,
  warning: 300000,
  error: 400000
};
